import { render, staticRenderFns } from "./votingActivity.vue?vue&type=template&id=48ca63d2&"
import script from "./votingActivity.vue?vue&type=script&lang=js&"
export * from "./votingActivity.vue?vue&type=script&lang=js&"
import style0 from "./votingActivity.vue?vue&type=style&index=0&id=48ca63d2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports